<template>
  <auth-layout title="Organization Information" stepNo="4" totalSteps="4">
    <div
      class="shadow rounded w-full md:w-11/12 mx-auto text-darkBlue mt-8 mb-8"
    >
      <div class="banner">
        <div class="pt-16 pl-6">
          <img
            src="@/assets/images/profile-img.png"
            alt="profile picture"
            class="w-32 h-32 img-fluid"
          />
        </div>
      </div>
      <div class="px-2 py-12">
        <form @submit.prevent class="">
          <div class="">
            <div class="container-fluid">
              <div class="row">
                <div class="col-md-6 col-lg-6 col-12">
                  <label class="label">Company Name <span class="text-red-500">*</span></label>
                  <base-input v-model="organizationInformation.companyname" />
                </div>
                <div class="col-md-6 col-lg-6 col-12">
                  <label class="label">Domain Name <span class="text-red-500">*</span></label>

                  <div>
                    <div class="flex">
                      <div
                        class="bg-darkBlue h-10 rounded flex justify-center items-center px-1"
                      >
                        <p class="text-white text-xs">https://muleex.com/</p>
                      </div>

                      <base-input
                      class="w-full"
                        v-model="organizationInformation.customdomain"
                      />
                    </div>

                    <small class="text-red-500" v-if="domainCheckError">{{
                      domainCheckError
                    }}</small>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6 col-lg-6 col-12">
                  <label class="label">Address <span class="text-red-500">*</span></label>
                  <vue-google-autocomplete id="map2" ref="companyAddress" 
                  classname="input" placeholder="Enter address" v-on:placechanged="getAddress">
                </vue-google-autocomplete>
                </div>
                <div class="col-md-6 col-lg-6 col-12">
                  <label class="label">Incorporation Number <span class="text-red-500">*</span></label>
                  <base-input v-model="organizationInformation.regnumber" />
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 col-lg-6 col-12">
                  <label class="label">Mobile Number (Preferably a WhatsApp number) <span class="text-red-500">*</span></label>
                  <vue-tel-input
                    v-model="organizationInformation.mobile_no"
                  ></vue-tel-input>
                  <div
                    v-if="
                      isValidPhone &&
                        organizationInformation.mobile_no.length > 0
                    "
                  >
                    <p class="text-red-600">
                      Phone number must be numeric values only
                    </p>
                  </div>
                  <div
                    v-if="
                      isValidPhoneLength &&
                        organizationInformation.mobile_no.length > 0
                    "
                  >
                    <p class="text-red-600">
                      Phone number must be 11 characters long
                    </p>
                  </div>
                </div>
                <div class="col-md-6 col-lg-6 col-12">
                  <label class="label">Email Address <span class="text-red-500">*</span></label>
                  <base-input
                    placeholder="Enter Your Email"
                    v-model="organizationInformation.email"
                    errorText="Please enter a valid email Address"
                    :validation="
                      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
                        organizationInformation.email
                      )
                    "
                  >
                    <template v-slot:icon>
                      <svg
                        width="19"
                        height="14"
                        viewBox="0 0 19 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16.941 0.283447H1.96132C1.63025 0.283447 1.31273 0.417552 1.07863 0.656259C0.84453 0.894966 0.713013 1.21872 0.713013 1.55631V11.7392C0.713013 12.0768 0.84453 12.4005 1.07863 12.6392C1.31273 12.8779 1.63025 13.012 1.96132 13.012H16.941C17.272 13.012 17.5896 12.8779 17.8237 12.6392C18.0578 12.4005 18.1893 12.0768 18.1893 11.7392V1.55631C18.1893 1.21872 18.0578 0.894966 17.8237 0.656259C17.5896 0.417552 17.272 0.283447 16.941 0.283447ZM15.5678 1.55631L9.45114 5.8713L3.33445 1.55631H15.5678ZM1.96132 11.7392V2.13546L9.09538 7.16962C9.19986 7.24352 9.32398 7.28313 9.45114 7.28313C9.5783 7.28313 9.70243 7.24352 9.80691 7.16962L16.941 2.13546V11.7392H1.96132Z"
                          fill="#FCC210"
                        />
                      </svg>
                    </template>
                  </base-input>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6 col-lg-6 col-12">
                  <label class="label">Industry <span class="text-red-500">*</span></label>
                  <el-select
                    filterable
                    v-model="organizationInformation.industry"
                    placeholder=""
                  >
                    <el-option
                      v-for="industry in industries"
                      :key="industry"
                      :label="industry"
                      :value="industry"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="col-md-6 col-lg-6 col-12">
                  <label class="label">Specialization <span class="text-red-500">*</span></label>
                  <el-select
                    filterable
                    v-model="organizationInformation.specialization"
                    placeholder=""
                    :disabled="!filteredSpecializations.length"
                  >
                    <el-option
                      v-for="specialization in filteredSpecializations"
                      :key="specialization"
                      :label="specialization"
                      :value="specialization"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
          </div>
          <div>
            <base-checkbox
              label="Terms of use"
              :bold="true"
              v-model="terms_of_use"
            />
          </div>
          <div class="flex justify-between px-2 mt-6">
            <base-button
              text="Back"
              background="#DAE8F6"
              p="py-2 px-8"
              @click="$router.push('/onboarding/account-owner')"
            />
            <base-button
              text="Finish"
              p="py-2 px-8"
              @click="saveOrganizationInformation"
              :disabled="isValidForm"
            />
          </div>
        </form>
      </div>
    </div>
    <template v-slot:text>
      <div class="text-white">
        <h1 class="text-3xl font-bold">Organisation Information</h1>
        <p class="text-sm">
          Done! You have succefully setup your MuleEx dashboard. You can always
          update these settings in your dashboard settings.
        </p>
      </div>
    </template>
    <modal :showModal="showModal" @close-modal="showModal = false" width="35">
      <div class="confirm-email">
        <p class="text-sm text-center py-4">
          It looks like you are using a private e-mail. It is advisable to use a
          company's e-mail. Please confirm to continue or edit.
        </p>
        <div class="button-wrapper">
          <button
            class="button button-long confirm"
            @click="(showModal = false), (privateEmailConfirmed = true)"
          >
            Confirm
          </button>
        </div>
      </div>
    </modal>
  </auth-layout>
</template>

<script>
import AuthLayout from "../../Auth/Authlayout/OnDemand";
import debounce from "@/utilities/debounce";
import VueGoogleAutocomplete from "vue-google-autocomplete";

import apiErrorHandler from "../../../mixins/apiErrorHandler";
import emailValidator from "../../../mixins/emailValidator";
import isNumber from "../../../mixins/isNumber";

import {
  organizationTypes,
  industries,
  specializations,
} from "@/utilities/globalVariables";
export default {
  components: {
    AuthLayout, VueGoogleAutocomplete
  },
  data() {
    return {
      debounce: "",
      domainCheckError: "",
      products: [],
      organizationInformation: {
        companyname: "",
        customdomain: "",
        industry: "",
        regnumber: "",
        mobile_no: "",
        email: "",
        specialization: "",
        address: "",
        userId: "",
        imageurl: "NA",
      },
      terms_of_use: false,
      organizationTypes: organizationTypes,
      industries: industries,
      specializations: specializations,
      savingOrganizationInfo: false,
      isUploadingImage: false,
      showModal: false,
      accountTypeObject: {}
    };
  },
  watch: {
    "organizationInformation.customdomain" : debounce(function(val) {
      if (val) {
        this.validateDomain();
      } else {
        this.domainCheckError = "";
      }
    }, 500),

    "organizationInformation.email"() {
      let { email } = this.organizationInformation;
      if (email.indexOf("@") >= 0 && email.indexOf(".") >= 0) {
        let start = email.indexOf("@") + 1;
        let end = email.indexOf(".");
        let emailClient = email.slice(start, end);
        if (emailClient == "gmail" || emailClient == "yahoo") {
          if (!this.privateEmailConfirmed) {
            this.showModal = true;
          }
        }
      }
    },
    "organizationInformation.industry"() {
      this.organizationInformation.specialization = "";
    },
    "organizationInformation.companyname"(v) {
      this.organizationInformation.customdomain = v
        .trim()
        .replace(/\s+/g, "-")
        .toLowerCase();
    },
  },
  mounted(){
    this.accountTypeObject = JSON.parse(localStorage.getItem("accountTypeObject"));
  },
  computed: {
    isValidEmail() {
      let validate = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return validate.test(this.organizationInformation.email);
    },
    isValidPhone() {
      let phone = this.organizationInformation.mobile_no;
      var patt = /[a-z]+/i;

      return patt.test(phone);
    },
    isValidPhoneLength() {
      return this.organizationInformation.mobile_no.replace(/\s+/g, "")
        .length != 11
        ? true
        : false;
    },
    disableNextButton() {
      let {
        companyname,
        customdomain,
        industry,
        regnumber,
        mobile_no,
        email,
        specialization,
        address,
      } = this.organizationInformation;
      if (
        companyname.length &&
        customdomain.length &&
        industry.length &&
        regnumber.length &&
        mobile_no.length &&
        email.length &&
        this.validateEmail(email) &&
        specialization.length &&
        address.length
      ) {
        return false;
      } else {
        return true;
      }
    },
    isValidForm() {
      return !this.terms_of_use ? true : false;
    },
    filteredSpecializations() {
      let indexOfSelectedIndustry = this.industries.indexOf(
        this.organizationInformation.industry
      );
      if (indexOfSelectedIndustry >= 0) {
        return this.specializations[indexOfSelectedIndustry];
      } else {
        return [];
      }
    },
  },

  mixins: [apiErrorHandler, emailValidator, isNumber],
  methods: {
    getAddress(addressData) {
      // const address = {
      //     name: addressData?.route,
      //     lat: addressData?.latitude,
      //     lng: addressData?.longitude,
      //     street_number: addressData?.street_number,
      //     locality: addressData?.locality,
      //     country: addressData.country,
      //     adm_1: addressData?.administrative_area_level_1,
      //     adm_2: addressData?.administrative_area_level_2
      //   }
      this.organizationInformation.address = addressData?.route
    },
    async validateDomain() {
      const inputDomain = this.organizationInformation.customdomain;
      try {
        const response = await this.$_validateDomain(inputDomain);
        if (response.data.exist) {
          this.domainCheckError = response.data.message;
          this.generateToast(response.data.message, "error");
        } else {
          this.domainCheckError = "";
        }
      } catch (error) {
        this.handleError(error);
        this.updatingUser = false;
      }
    },
    async saveOrganizationInformation() {
      this.savingOrganizationInfo = true;

      let userId = localStorage.getItem("userId");
      if (!userId) {
        this.$router.push("/signup");
      }
      this.organizationInformation.userId = userId;
      this.organizationInformation.token = localStorage.getItem("quantumToken");
      this.organizationInformation.orgId = localStorage.getItem("quantumOrgId");
      this.organizationInformation.defaultLocation = localStorage.getItem(
        "defaultLocation"
      );
      try {
        let response = await this.$_saveOrganizationInformation(
          this.organizationInformation
        );
        console.log(response);
        this.onSuccessfulRequest();
      } catch (error) {
        console.log(error);
        this.handleError(error);
        this.savingOrganizationInfo = false;
      }
    },
    getUserId() {
      let userId = localStorage.getItem("userId");
      return userId;
    },
    onSuccessfulRequest() {
      this.saveOrganizationInformation = false;
      this.$router.push("/onboarding/complete");
    },
    async uploadImage(image) {
      // console.log(image);
      this.isUploadingImage = true;
      const formData = new FormData();
      formData.append("file", image);
      formData.append("upload_preset", "zunt8yrw");
      try {
        let response = await this.$_uploadImage(formData);
        // console.log(response);
        this.organizationInformation.imageurl = response.data.secure_url;
        this.isUploadingImage = false;
        this.generateToast("Image uploaded", "success");
      } catch (error) {
        this.handleError(error);
        this.isUploadingImage = false;
      }
    },
    removeImage() {
      this.organizationInformation.imageurl = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.banner {
  width: 100%;
  height: 9rem;
  background-color: rgb(6, 6, 71);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.row > div {
  padding: 0 0.5rem;
}
</style>
